module.exports = __webpack_public_path__ + "img/delivery.572d1050.svg";